import { render, staticRenderFns } from "./ShopAdministrationCard.vue?vue&type=template&id=5de336de&scoped=true&"
import script from "./ShopAdministrationCard.vue?vue&type=script&lang=js&"
export * from "./ShopAdministrationCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopAdministrationCard.vue?vue&type=style&index=0&id=5de336de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de336de",
  null
  
)

export default component.exports